import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApiStatus } from 'common/enums';
import { IErrorResponse } from 'common/models/api-service/error-response.model';

import initialAppUserState from './user.state';
import { UserInfo } from 'common/models/user-model';

const userSlice = createSlice({
    name: 'user',
    initialState: initialAppUserState,
    reducers: {
        getUserProfile: (state) => {
            state.name = '';
        },
        getUserProfileSuccess: (state, { payload }: PayloadAction<any>) => {
            state.id = payload.id;
            state.name = payload.givenName;
            state.emailId = payload.mail;
            state.profileApiStatus = ApiStatus.SUCCESS;
        },
        getUserProfileError: (state, { payload }: PayloadAction<IErrorResponse>) => {
            state.profileApiStatus = ApiStatus.ERROR;
        },
        getUserAvatarSuccess: (state, { payload }: PayloadAction<string>) => {
            state.avatar = payload;
        },
        getUserAvatarError: (state) => {
            state.avatar = '';
        },
        getUserInfo: (state) => {
            state.userInfo.status = ApiStatus.LOADING;
        },
        getUserInfoSuccess: (state, { payload }: PayloadAction<UserInfo>) => {
            state.userInfo.status = ApiStatus.SUCCESS;
            state.userInfo.data = payload;
        },
        getUserInfoError: (state) => {
            state.userInfo.status = ApiStatus.ERROR;
        }
    }
});

export default userSlice.reducer;
export const userActions = userSlice.actions;
